import { UserType } from 'library/ts/model/user/UserType';
import { ITag } from 'tag/ts/tag/interfaces/ITag';
import { IParamsVO } from 'tag/ts/tag/interfaces/params/IParamsVO';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';

export class PlayStation5 extends AbstractSTVPlatformConfig {
	constructor( params: IParamsVO, tag: ITag ) {
		super( params );

		// set advanced DRM configs PLSTVVID-1384: needed for PS5 CF playback
		const userType = tag.tagUtilities.getUserType( params?.USER?.userStatus );

		const drmConfigs = userType === UserType.CF ?
			{
				adapter: {
					options: {
						config: {
							drm: {
								advanced: {
									'com.microsoft.playready': {
										persistentStateRequired: true,
										sessionType: 'persistent-license'
									}
								}
							}
						}
					}
				}
			} : {};

		const baseConfigs = {
			properties: {
				device: EmbedDevice.PS5
			},
			resourceConfig: {
				// PLSTVVID-1464: optimal buffer settings derived by Agajan to solve buffer loop issue. Consult VTG before changing.
				playback: {
					abr: {
						capQualityToScreenSize: false
					},
					streaming: {
						stallEnabled: true,
						stallSkip: 1.2,
						stallThreshold: 2,
						jumpLargeGaps: true
					},
					...drmConfigs
				}
			}
		};

		this.configs = this.utils.DeepMerge.deepmerge( this.configs, baseConfigs );
	}

}